/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const diamond_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.773 2.169c.211.111.395.272.537.471l3.386 4.748c.205.289.312.641.303 1.001m-4.226-6.22A1.463 1.463 0 0 0 18.092 2h-6.091m6.772.169-2.125 6.22M5.23 2.17c.211-.112.444-.17.68-.17h6.091m-6.772.169a1.543 1.543 0 0 0-.537.471L1.304 7.388a1.66 1.66 0 0 0-.303 1.001m4.228-6.22 2.124 6.22M1 8.39c.008.36.133.707.352.984l9.48 12.054A1.51 1.51 0 0 0 12 22M1 8.39h6.353M12 22a1.51 1.51 0 0 0 1.167-.573l9.48-12.054A1.65 1.65 0 0 0 23 8.389M12 22 7.353 8.39M12 22l4.648-13.61m6.352 0h-6.352m-9.295 0L12 2M7.353 8.39h9.295M12.001 2l4.647 6.39"
    />
  </svg>
)
export default diamond_medium
